import { useCallback, useState } from 'react';

const STORAGE_KEY = 'gearbelt:export-auto-download';

function readPreference(): boolean {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === null ? true : stored === 'true';
  } catch {
    return true;
  }
}

/**
 * Persisted "automatically download when ready" preference for exports. Defaults
 * to on and survives across sessions so the export tab's checkbox is sticky.
 */
export function useAutoDownloadPreference(): [boolean, (value: boolean) => void] {
  const [autoDownload, setAutoDownload] = useState(readPreference);

  const update = useCallback((value: boolean) => {
    setAutoDownload(value);
    try {
      window.localStorage.setItem(STORAGE_KEY, String(value));
    } catch {
      // Private-mode / quota failures still leave the in-memory value applied.
    }
  }, []);

  return [autoDownload, update];
}
